import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, toDisplayString as _toDisplayString, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["type", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_3 = {
  key: 1,
  class: "fas fa-edit"
}
const _hoisted_4 = {
  key: 2,
  class: "fas fa-upload"
}
const _hoisted_5 = {
  key: 3,
  class: "fas fa-camera"
}
const _hoisted_6 = {
  key: 2,
  class: "whitespace-nowrap"
}

interface Props {
  label?: string;
  icon?: string;
  showIcon?: boolean;
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | 'modifier' | 'upload' | 'upload-photo';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  loading?: boolean;
  customClass?: string;
}

// Props réactives

export default /*@__PURE__*/_defineComponent({
  __name: 'ActionButton',
  props: {
    label: {},
    icon: {},
    showIcon: { type: Boolean, default: true },
    variant: { default: 'primary' },
    size: { default: 'md' },
    type: { default: 'button' },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    customClass: { default: '' }
  },
  emits: ["click"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: _ctx.type,
    disabled: _ctx.disabled,
    class: _normalizeClass([
      'px-4 py-2 text-sm rounded-lg transition-all duration-200 flex items-center justify-center gap-2 font-medium min-h-[44px]',
      // Variants
      _ctx.variant === 'primary' && 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2',
      _ctx.variant === 'secondary' && 'border border-gray-300 text-gray-700 hover:bg-gray-50 focus:ring-2 focus:ring-gray-500 focus:ring-offset-2',
      _ctx.variant === 'success' && 'bg-green-600 text-white hover:bg-green-700 focus:ring-2 focus:ring-green-500 focus:ring-offset-2',
      _ctx.variant === 'danger' && 'bg-red-600 text-white hover:bg-red-700 focus:ring-2 focus:ring-red-500 focus:ring-offset-2',
      _ctx.variant === 'warning' && 'bg-yellow-600 text-white hover:bg-yellow-700 focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2',
      _ctx.variant === 'info' && 'bg-cyan-600 text-white hover:bg-cyan-600 focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2',
      _ctx.variant === 'light' && 'bg-gray-100 text-gray-700 hover:bg-gray-200 focus:ring-2 focus:ring-gray-500 focus:ring-offset-2',
      _ctx.variant === 'dark' && 'bg-gray-800 text-white hover:bg-gray-900 focus:ring-2 focus:ring-gray-500 focus:ring-offset-2',
      // Action variants spécifiques
      _ctx.variant === 'modifier' && 'bg-blue-500 text-white hover:bg-blue-600 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 border border-blue-400',
      _ctx.variant === 'upload' && 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 border border-blue-500',
      _ctx.variant === 'upload-photo' && 'bg-cyan-500 text-white hover:bg-cyan-600 focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2 border border-cyan-400',
      // Sizes
      _ctx.size === 'sm' && 'px-3 py-1.5 text-xs min-h-[36px]',
      _ctx.size === 'md' && 'px-4 py-2 text-sm min-h-[40px]',
      _ctx.size === 'lg' && 'px-6 py-3 text-base min-h-[44px]',
      _ctx.size === 'xl' && 'px-8 py-4 text-lg min-h-[48px]',
      // States
      _ctx.disabled && 'opacity-50 cursor-not-allowed',
      _ctx.loading && 'cursor-wait',
      // Animations
      'hover:transform hover:scale-105 active:scale-95',
      // Custom classes
      _ctx.customClass
    ]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click', $event)))
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("i", _hoisted_2))
      : (_ctx.showIcon)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.icon)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  class: _normalizeClass(_ctx.icon)
                }, null, 2))
              : (_ctx.variant === 'modifier')
                ? (_openBlock(), _createElementBlock("i", _hoisted_3))
                : (_ctx.variant === 'upload')
                  ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                  : (_ctx.variant === 'upload-photo')
                    ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                    : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})